module.exports = __webpack_public_path__ + "img/20200613_094532.696c46f0.jpg";